import dayjs from "dayjs";

export const getDueDateFromPaymentTerm = (paymentTerm, startDate) => {
  const date = dayjs(startDate); // always wrap in dayjs
  if (!date.isValid()) return null;

  switch (paymentTerm) {
    case "Immediate":
      return date;
    case "Net 7":
      return date.add(7, "day");
    case "Net 15":
      return date.add(15, "day");
    case "Net 30":
      return date.add(30, "day");
    case "Net 45":
      return date.add(45, "day");
    case "Net 60":
      return date.add(60, "day");
    case "End of the Month":
      return date.endOf("month");
    case "End of the next Month":
      return date.add(1, "month").endOf("month");
    default:
      return date;
  }
};